import { createClient, deleteClient, editClient, getClient, getClients, getClientSelections, } from './services/client-service';
import { useAppQuery } from '@/lib/api/services/helpers/useAppQuery';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '@/lib/zustand/auth-store';
import { getBaseMutationOptions } from '@/lib/api/services/helpers/base-mutation-options';
import { defaultApiOptions } from '@/lib/api/services/helpers/default-option';
export const useClientSelectionQuery = (filter = {}) => {
    return useAppQuery(['clientSelections', filter], (token) => getClientSelections(token, filter));
};
export const useClientsQuery = (filter = {}) => {
    return useAppQuery(['clients', filter], (token) => getClients(token, filter));
};
export const useClientQuery = (clientId) => {
    return useAppQuery(['client', clientId], (token) => getClient(token, clientId));
};
export const useCreateClient = (options = defaultApiOptions) => {
    const queryClient = useQueryClient();
    const { accessToken } = useAuthStore();
    const navigate = useNavigate();
    return useMutation({
        mutationFn: (payload) => createClient(accessToken, payload),
        ...getBaseMutationOptions({
            navigate,
            options,
            queryClient,
            queryKey: ['clients', 'client'],
        }),
    });
};
export const useEditClient = (options = defaultApiOptions) => {
    const queryClient = useQueryClient();
    const { accessToken } = useAuthStore();
    const navigate = useNavigate();
    return useMutation({
        mutationFn: (payload) => editClient(accessToken, payload),
        ...getBaseMutationOptions({
            navigate,
            options,
            queryClient,
            queryKey: ['clients', 'client'],
        }),
    });
};
export const useDeleteClient = (options = defaultApiOptions) => {
    const queryClient = useQueryClient();
    const { accessToken } = useAuthStore();
    const navigate = useNavigate();
    return useMutation({
        mutationFn: (deletedClientId) => deleteClient(accessToken, deletedClientId),
        ...getBaseMutationOptions({
            navigate,
            options,
            queryClient,
            queryKey: ['clients'],
        }),
    });
};
